import React, { useRef } from 'react';
import { Box, Typography, TextField, Avatar, Button, Checkbox, FormControlLabel } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import UploadIcon from '@mui/icons-material/Upload';
import { FlowDetailsProps } from '../types/props.types';
import { COLORS_CONFIG_PAGE } from '../../conf/constants';

const FlowDetails: React.FC<FlowDetailsProps> = ({
  flowEditData,
  setFlowEditData,
  selectedFlowData,
  handleUpdateFlow,
  handleUploadIcon,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <Box p={3} sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h6" gutterBottom>Process Flow</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <TextField
          label="Name"
          value={flowEditData.name}
          onChange={(e) => setFlowEditData({ ...flowEditData, name: e.target.value })}
          fullWidth
          size="small"
        />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 200 }}>
          <Typography variant="body2">Icon</Typography>
          <Avatar sx={{ mr: 2, bgcolor: 'transparent' }}>
            {selectedFlowData?.iconUrl ? (
              <img
                src={selectedFlowData.iconUrl}
                alt={`${selectedFlowData?.name} icon`}
                style={{ width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  maxWidth: '20px', 
                  maxHeight: '20px', }}
              />
            ) : null}
          </Avatar>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                handleUploadIcon(file);
              }
            }}
          />
          <Button
            variant="contained"
            size="small"
            startIcon={<UploadIcon />}
            onClick={handleUploadClick}
            sx={{ bgcolor: COLORS_CONFIG_PAGE.primary, '&:hover': { bgcolor: COLORS_CONFIG_PAGE.primary } }}
          >
            UPLOAD
          </Button>
        </Box>
      </Box>
      <TextField
        label="Description"
        value={flowEditData.description}
        onChange={(e) => setFlowEditData({ ...flowEditData, description: e.target.value })}
        fullWidth
        size="small"
        multiline
      />
      <Box sx={{ mt: 'auto', pt: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={flowEditData.isActive}
                onChange={(e) => setFlowEditData({ ...flowEditData, isActive: e.target.checked })}
              />
            }
            label="Is Active?"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={flowEditData.isSpecial}
                onChange={(e) => setFlowEditData({ ...flowEditData, isSpecial: e.target.checked })}
              />
            }
            label="Is Special?"
          />
        </Box>
        
        <Button
          variant="contained"
          startIcon={<RefreshIcon />}
          onClick={handleUpdateFlow}
          sx={{ bgcolor: COLORS_CONFIG_PAGE.primary }}
        >
          SAVE
        </Button>
      </Box>
    </Box>
  );
};

export default FlowDetails;